/**
 * Which surface the SPA is running on. The whole route tree is already keyed
 * off the host in main.tsx; pages that need to adapt (e.g. the blog, which is
 * an authoring tool in the portal and a review queue for admins) reuse this.
 */
export type Surface = 'admin' | 'portal';

export function currentSurface(): Surface {
  return window.location.hostname.startsWith('admin.') ? 'admin' : 'portal';
}

export const isAdminSurface = currentSurface() === 'admin';
